import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { MatDialog } from "@angular/material";
import { SignatureConfigService } from "src/app/core/services/signature-config.service";
import { SignatureConfig } from "src/app/shared/models/signature-config.model";
import { DialogSignatureConfigComponent } from "../dialog-signature-config/dialog-signature-config.component";
import {element} from 'protractor';
import {SignaturePosition} from '../../../../../../../shared/models/signature-position.model';

@Component({
  selector: "app-signature-config",
  templateUrl: "./signature-config.component.html",
  styleUrls: ["./signature-config.component.scss"],
})
export class SignatureConfigComponent implements OnInit, OnChanges {
  dataSource: SignatureConfig[];
  displayedColumns: string[] = ["stt", "name", "subject", "page", "action"];
  public timeOut: any = null;
  public nameFilter: string;
  public hasEnterprise: string = "";
  @Input() enterpriseSign: any
  @Input() dataSignatureConfig: SignatureConfig[];
  @Input("template_id") templateId: number;
  @Output() signatureConfigSaved: EventEmitter<void> = new EventEmitter();
  approverNumber: any;
  checkApprover = false;

  constructor(
    private dialog: MatDialog,
    public signatureConfigService: SignatureConfigService
  ) {
    this.approverNumber = localStorage.getItem('approverNumber');
  }

  ngOnInit() {
    this.filterTable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataSignatureConfig) {
      this.dataSource = this.dataSignatureConfig;
    }
  }

  onOpenDialogSignatureConfig(element: SignatureConfig) {
    if (element.object !== "ENTERPRISE") {
      this.dataSignatureConfig.forEach((item) => {
        if (item.object === "ENTERPRISE") {
          this.hasEnterprise = item.object;
        }
      });
    } else {
      this.hasEnterprise = null;
    }
    const listApprover = [];
    this.dataSignatureConfig.forEach((item) => {
      if (item.object === "ENTERPRISEAPPROVER" && item.signatureId !== element.signatureId) {
        listApprover.push(item);
      }
    });
    this.checkApprover = listApprover.length === Number(this.approverNumber) || listApprover.length > Number(this.approverNumber);
    const dialog = this.dialog.open(DialogSignatureConfigComponent, {
      width: "80%",
      height: "auto",
      data: { data: element, hasEnterprise: this.hasEnterprise, checkApprover: this.checkApprover, approverNumber: Number(this.approverNumber) },
    });

    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.signatureConfigSaved.emit();
      }
    });
  }

  filterTable() {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }

    if (!this.nameFilter || (this.nameFilter && !this.nameFilter.trim())) {
      this.dataSource = this.dataSignatureConfig;
      return;
    }

    this.timeOut = setTimeout(() => {
      this.dataSource = [];
      const nameFind = this.nameFilter
        ? this.removeVietnameseTones(this.nameFilter.trim()).toLowerCase()
        : null;
      this.dataSignatureConfig.forEach((item) => {
        const name = item.name
          ? this.removeVietnameseTones(item.name.trim()).toLowerCase()
          : null;

        if (nameFind && name && name.includes(nameFind)) {
          this.dataSource.push(item);
        }
      });
    });
  }

  clearData() {
    this.nameFilter = null;
    this.filterTable();
  }

  removeVietnameseTones(str) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    // Some system encode vietnamese combining accent as individual utf-8 characters
    // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
    // Remove extra spaces
    // Bỏ các khoảng trắng liền nhau
    // str = str.replace(/ + /g, " ");
    str = str.trim();
    return str;
  }

  displayTooltip(data, index, class_name) {
    let elms_span = document.getElementsByClassName(class_name);
    let elms_cell = document.getElementsByClassName("cellForSignature");
    if (
      index &&
      elms_span.item(index) &&
      elms_cell.item(index) &&
      elms_span.item(index).scrollWidth > elms_cell.item(index).scrollWidth
    ) {
      return data;
    } else {
      return null;
    }
  }
}
